import { ButtonTriggerEvent } from '../../../../common/components';

export class TripDetailModalActions {
    confirm: (event: ButtonTriggerEvent) => void;
    cancel?: () => void;
}

export class TripDetailModalData {
    public item: any;
    public type: string;
    public index: number;
    public hubName: string;
    public parentUrlTripID: string;
    public parentUrlTripFromUserID: string;
    public isShowAddToTripBtn: boolean;

    constructor(item: any, displayingOn: string, hubName: string, parentUrlTripID, parentUrlTripFromUserID, isShowAddToTripBtn, index?: number) {
        this.item = item;
        this.type = displayingOn;
        this.index = index;
        this.hubName = hubName;
        this.parentUrlTripID = parentUrlTripID;
        this.parentUrlTripFromUserID = parentUrlTripFromUserID;
        this.isShowAddToTripBtn = isShowAddToTripBtn;
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/trip/trip.detail.modal/trip.detail.modal.provider.ts